import { EventInfoType } from '@amzn/ring-web-analytics';

export const getScreenState = () => {
  const width = window.screen.width;
  const height = window.screen.height;
  return {
    windowWidth: width,
    windowHeight: height,
    orientation: width > height ? 'l' : 'p',
  };
};

export const mapEventToRWA = (eventName: string) => ({
  resourceId: `${eventName}_${Date.now()}`,
  type: EVENT_TYPE_MAP[eventName],
  ...getScreenState(),
});

const EVENT_TYPES: Partial<Record<EventInfoType, readonly string[]>> = {
  click: [
    'Like Post',
    'Unlike Post',
    'Feed Card Click',
    'Hide Post Click',
    'Hide Post Confirm Click',
    'Report Post Click',
    'Share Link Click',
    'Comment Post',
    'Reply Comment',
    'Like Comment',
    'Unlike Comment',
    'Report Comment Click',
    'CTA Modal - Download App',
    'Join Neighbors Modal',
    'CTA Bottom Tray - Download App',
    'Ring Account Map',
    'Ring Account Banner',
    'Banner CTA',
    'Opportunity Card - Click',
    'Created Post',
  ],
  open: [
    'CTA Modal - Open',
    'Category Selector View',
    'Posting Guidelines View',
    'Location Selection View',
    'Media Upload View',
    'Post Details View',
    'Preview Post View',
    'Schedule For Later View',
  ],
};

const createEventTypeMap = (
  eventTypes: Partial<Record<EventInfoType, readonly string[]>>,
): Record<string, EventInfoType> => {
  const map: Record<string, EventInfoType> = {};

  for (const [type, events] of Object.entries(eventTypes)) {
    for (const event of events) {
      map[event] = type as EventInfoType;
    }
  }

  return map;
};

export const EVENT_TYPE_MAP = createEventTypeMap(EVENT_TYPES);
